<template>
<div>

<!-- MENU USUARIOS DE GRUPO AGENCIA ADUANAL-->
   <v-menu text nav v-if="es_agente && view_catalogos_manifiesto && !view_carta_porte" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>fa fa-list </v-icon>
                    <span class="caption">Administración</span>
                </v-btn>
            </template>

            <v-list :tile="false" nav>

         
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.catalogos.aduanas')" to="/grupo/catalogos/aduanas" @click.shift="openNew('/grupo/catalogos/aduanas');">
                    <v-icon>mdi-circle-small</v-icon>Aduanas
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.catalogos.sellos.editar')" to="/carta_porte/catalogos/registro_fiscal" @click.shift="openNew('/carta_porte/catalogos/registro_fiscal');">
                    <v-icon>mdi-circle-small</v-icon>Datos Fiscales CFDI
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.catalogos.sellos.editar')" to="/agentes/certificadosagentes" @click.shift="openNew('/agentes/certificadosagentes');">
                    <v-icon>mdi-circle-small</v-icon>Sellos Fiscales Recuperación
                </app-bar-item>
                <app-bar-item  v-if="(valida_permiso_t('EmanifiestoAA.catalogos.usuarios.crear') || valida_permiso_t('EmanifiestoAA.catalogos.usuarios.consultar')) && es_agente" to="/usuariost" @click.shift="openNew('/usuariost');">
                    <v-icon>mdi-circle-small</v-icon>Usuarios
                </app-bar-item>
                 <app-bar-item v-if="(valida_permiso_t('EmanifiestoAA.catalogos.clientes.crear') || valida_permiso_t('EmanifiestoAA.catalogos.clientes.consultar')) && es_agente" to="/listaclientest" @click.shift="openNew('/listaclientest');">
                    <v-icon>mdi-circle-small</v-icon>Clientes
                </app-bar-item>


            </v-list>
    </v-menu>


     <!-- data stage -->

        <v-menu text nav v-if="es_agente && view_menu_ds && !view_carta_porte" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>attach_file</v-icon>
                    <span class="caption">Data Stage</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.datastage.cargar')"  to="/datastage/aa_cargazip" @click.shift="openNew('/datastage/aa_cargazip');">
                    <v-icon>mdi-circle-small</v-icon>Carga Zip
                </app-bar-item>
               <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.datastage.bitacora')" to="/datastage/aa_bitacorazip" @click.shift="openNew('/datastage/aa_bitacorazip');">
                    <v-icon>mdi-circle-small</v-icon>Bitácora ZIP
                </app-bar-item>
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.datastage.reportes.directods')"  to="/datastage/aa_directo_ds" @click.shift="openNew('/datastage/aa_directo_ds');">
                    <v-icon>mdi-circle-small</v-icon>Reportes Directos DS
                </app-bar-item>
                <v-divider />
                <app-bar-item   to="/indexAA" @click.shift="openNew('/indexAA');">
                    <v-icon>mdi-circle-small</v-icon>Dashboard
                </app-bar-item>
            </v-list>
        </v-menu>


    <v-menu text nav v-if="es_agente && view_menu_carga && !view_carta_porte" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>fa fa-upload </v-icon>
                    <span class="caption">Carga de Información</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>

                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.archivom.cargar')" to="/ce_cargazip" @click.shift="openNew('/ce_cargazip');">
                    <v-icon>mdi-circle-small</v-icon>Carga Archivos M
                </app-bar-item>
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.archivom.consultar') " to="/ce_bitacora" @click.shift="openNew('/ce_bitacora');">
                    <v-icon>mdi-circle-small</v-icon>Bitácora Archivos M
                </app-bar-item>
              
                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.archivom.cargar')" to="/manifestacion/transmitir" @click.shift="openNew('/manifestacion/transmitir');">
                    <v-icon>mdi-circle-small</v-icon>Manifestación de Valor
                </app-bar-item>
                <v-divider />
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.facturas.cargar')" to="/ce_cargazipfacturas" @click.shift="openNew('/ce_cargazipfacturas');">
                    <v-icon>mdi-circle-small</v-icon>Carga ZIP CFDI
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.facturas.consultar')" to="/ce_facturastransito" @click.shift="openNew('/ce_facturastransito');">
                    <v-icon>mdi-circle-small</v-icon>Bitáctora CFDI
                </app-bar-item>
                <v-divider />
                <app-bar-item   to="/indexm" @click.shift="openNew('/indexm');">
                    <v-icon>mdi-circle-small</v-icon>Dashboard
                </app-bar-item>

            </v-list>
    </v-menu>
     <v-menu text nav v-if="es_agente && view_menu_edrive_emanifiesto && !view_carta_porte" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>account_tree </v-icon>
                    <span class="caption">eDrive</span>
                </v-btn>
            </template>
       

           
           <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.edrive.consultar')" to="/edrive/exploreraa" @click.shift="openNew('/edrive/exploreraa');">
                    <v-icon>mdi-circle-small</v-icon>Consultar Expediente Pedimentos
                </app-bar-item>

                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.edrive.descargar')" to="/expediente_pedimentoaa" @click.shift="openNew('/expediente_pedimentoaa');">
                    <v-icon>mdi-circle-small</v-icon>Descargar Expediente Pedimentos
                </app-bar-item>

                <v-menu v-if="(valida_permiso_t('EmanifiestoAA.edrive.descargar') || valida_permiso_t('EmanifiestoAA.edrive.descargar'))" open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on" id="menuAdjuntos">
                            <app-bar-item @click.native="hideMenuAdjuntos">

                                <v-icon>mdi-circle-small</v-icon>Adjuntos a Expediente<v-icon>mdi-menu-right</v-icon>

                            </app-bar-item>
                        </span>
                    </template>

                    <v-list :tile="false" nav>
                        <app-bar-item @click.native="hideMenuAdjuntos" v-if="valida_permiso_t('EmanifiestoAA.edrive.descargar')" to="/adjuntos_pedimento_aa" @click.shift="openNew('/adjuntos_pedimento_aa');">
                            <v-icon>mdi-circle-small</v-icon>Carga Adjuntos a Expediente
                        </app-bar-item>
                        <app-bar-item @click.native="hideMenuAdjuntos" v-if="valida_permiso_t('EmanifiestoAA.edrive.descargar')" to="/vucem/adjuntar_edocument_aa" @click.shift="openNew('/vucem/adjuntar_edocument_aa');">
                            <v-icon>mdi-circle-small</v-icon>Adjuntar eDocuments
                        </app-bar-item>

                        <app-bar-item @click.native="hideMenuAdjuntos" v-if="valida_permiso_t('EmanifiestoAA.edrive.descargar') " to="/bandeja_temporal_aa" @click.shift="openNew('/bandeja_temporal_aa');">
                            <v-icon>mdi-circle-small</v-icon>Expediente en Proceso
                        </app-bar-item>

                        <app-bar-item @click.native="hideMenuAdjuntos" v-if="valida_permiso_t('EmanifiestoAA.edrive.descargar')" to="/consulta_adjuntos_aa" @click.shift="openNew('/consulta_adjuntos_aa');">
                            <v-icon>mdi-circle-small</v-icon>Consulta Archivos Adjuntos
                        </app-bar-item>
                    </v-list>
                </v-menu>

                <v-divider />
                <!-- <v-divider /> -->
                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.edrive.consultar')" to="/edrivet" @click.shift="openNew('/edrivet');">
                    <v-icon>mdi-circle-small</v-icon>Consultar Expediente Archivos M
                </app-bar-item>

                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.edrive.descargar')" to="/ce_expedientem" @click.shift="openNew('/ce_expedientem');">
                    <v-icon>mdi-circle-small</v-icon>Descargar Expediente  Archivos M
                </app-bar-item>
                <v-divider />
           
                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.edrive.consultar')" to="/vucemaa/recuperaciones_agentes" @click.shift="openNew('/vucemaa/recuperaciones_agentes');">
                    <v-icon>mdi-circle-small</v-icon>Recuperaciones en Pedimentos
                </app-bar-item>
                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.edrive.consultar')" to="/vucemaa/recuperaciones" @click.shift="openNew('/vucemaa/recuperaciones');">
                    <v-icon>mdi-circle-small</v-icon>Recuperaciones en Archivos M
                </app-bar-item>
                
            </v-list>
    </v-menu>
    <v-menu text nav v-if="es_agente && !view_carta_porte" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>swap_vert </v-icon>
                    <span class="caption">Vucem-Pedimento</span>
                </v-btn>
            </template>
           <v-list :tile="false" nav>
            <app-bar-item  to="/vucemaa/layout" @click.shift="openNew(' /vucemaa/layout');">
                    <v-icon>mdi-circle-small</v-icon>Solicitudes de Consulta
            </app-bar-item>
            <v-divider />
            <app-bar-item  to="/vucemaa/consultar_pedimentos_agentes" @click.shift="openNew(' /vucemaa/consultar_pedimentos_agentes');">
                    <v-icon>mdi-circle-small</v-icon>Consultar Pedimentos
                </app-bar-item>
                <app-bar-item  to="/vucemaa/consultar_coves_m" @click.shift="openNew('/vucemaa/consultar_coves_m');">
                    <v-icon>mdi-circle-small</v-icon>Consultar COVES
                </app-bar-item>

                <app-bar-item  to="/vucemaa/consultar_edocs_m" @click.shift="openNew('/vucemaa/consultar_edocs_m');">
                    <v-icon>mdi-circle-small</v-icon>Consulta EDOCUMENTS
                </app-bar-item>
            </v-list>
    </v-menu>
    <v-menu text nav v-if="es_agente  && view_menu_reportes_emanifiesto && !view_carta_porte" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>fa fa-file-excel</v-icon>
                    <span class="caption">Reportes</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item  to="/datastage/predeterminadosds" @click.shift="openNew('/datastage/predeterminadosds'); ">
                    <v-icon>mdi-circle-small</v-icon>Reporte Predeterminados DS
                </app-bar-item>
                <v-divider />
                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.reportes.directom')"  to="/ce_directom" @click.shift="openNew('/ce_directom'); ">
                    <v-icon>mdi-circle-small</v-icon>Reporte Archivos M
                </app-bar-item>
                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.reportes.comercio') "  to="/ce_reporteexterior" @click.shift="openNew('/ce_reporteexterior'); ">
                    <v-icon>mdi-circle-small</v-icon> Reporte CFDI Comercio Exterior
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.reportes.comercio.detalle') " to="/ce_reportedetalle" @click.shift="openNew('/ce_reportedetalle');">
                    <v-icon>mdi-circle-small</v-icon>Reporte CFDI Detallado
               </app-bar-item>
               <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.reportes.layout.cp') " to="/carta_porte/layoutcfdi" @click.shift="openNew('/carta_porte/layoutcfdi');">
                    <v-icon>mdi-circle-small</v-icon>Layout Carta Porte
               </app-bar-item>
           
                <v-divider />
                <app-bar-item to="/catalogos/etipsHTML" @click.shift="openNew('/catalogos/etipsHTML');">
                    <v-icon>mdi-circle-small</v-icon> Manual de Usuario
                </app-bar-item>

                <app-bar-item to="/videotutorial" @click.shift="openNew('/videotutorial');">
                    <v-icon>mdi-circle-small</v-icon>Consulta Video Tutoriales
                </app-bar-item>
            </v-list>
    </v-menu>

    

    <!--  CATALOGOS CARTA PORTE-->
   <v-menu text nav v-if="es_agente && view_catalogos_cp && view_carta_porte" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>fa fa-list </v-icon>
                    <span class="caption">Administración</span>
                </v-btn>
            </template>

            <v-list :tile="false" nav>

                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.A.catalogos.receptores.crear') || valida_permiso_t('EmanifiestoAA.catalogos.receptores.consultar')" to="/carta_porte/catalogos/clientes" @click.shift="openNew('/carta_porte/catalogos/clientes');">
                    <v-icon>mdi-circle-small</v-icon>Receptores
                </app-bar-item>
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.A.catalogos.ubicaciones.crear') || valida_permiso_t('EmanifiestoAA.catalogos.ubicaciones.consultar')" to="/carta_porte/catalogos/ubicaciones" @click.shift="openNew('/carta_porte/catalogos/ubicaciones');">
                    <v-icon>mdi-circle-small</v-icon>Ubicaciones
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.A.catalogos.servicios.crear') || valida_permiso_t('EmanifiestoAA.catalogos.servicios.consultar')" to="/carta_porte/catalogos/productos" @click.shift="openNew('/carta_porte/catalogos/productos');">
                    <v-icon>mdi-circle-small</v-icon>Servicios
                </app-bar-item>
                 <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.A.catalogos.productos.crear') || valida_permiso_t('EmanifiestoAA.catalogos.productos.consultar')" to="/carta_porte/catalogos/materiales" @click.shift="openNew('/carta_porte/catalogos/materiales');">
                    <v-icon>mdi-circle-small</v-icon>Productos y Mercancias
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.catalogos.figuras.crear') || valida_permiso_t('EmanifiestoAA.catalogos.figuras.consultar')" to="/carta_porte/catalogos/figuras_transporte" @click.shift="openNew('/carta_porte/catalogos/figuras_transporte');">
                    <v-icon>mdi-circle-small</v-icon>Figuras Transporte
                </app-bar-item>
                 <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.catalogos.remolques.crear') || valida_permiso_t('EmanifiestoAA.catalogos.remolques.consultar')" to="/carta_porte/catalogos/remolques" @click.shift="openNew('/carta_porte/catalogos/remolques');">
                    <v-icon>mdi-circle-small</v-icon>Remolques
                </app-bar-item>
                    <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.catalogos.transportes.crear') || valida_permiso_t('EmanifiestoAA.catalogos.transportes.consultar')" to="/carta_porte/catalogos/transportes" @click.shift="openNew('/carta_porte/catalogos/transportes');">
                    <v-icon>mdi-circle-small</v-icon>Transportes
                </app-bar-item>
                <v-divider v-if="valida_permiso_t('EmanifiestoAA.catalogos.mercancias.consultar') || valida_permiso_t('EmanifiestoAA.catalogos.seguros.consultar')" />
                 <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.catalogos.mercancias.consultar')" to="/carta_porte/catalogos/materiales_grupo" @click.shift="openNew('/carta_porte/catalogos/materiales_grupo');">
                    <v-icon>mdi-circle-small</v-icon>Consulta base de clasificación Mercancías
                </app-bar-item>
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.catalogos.seguros.consultar')" to="/carta_porte/reportes/seguros" @click.shift="openNew('/carta_porte/reportes/seguros');  ">
                    <v-icon>mdi-circle-small</v-icon>Consultar Seguros
                </app-bar-item>
            </v-list>
    </v-menu>

    
            <v-menu text nav v-if="es_agente && view_cfdi && view_carta_porte" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>fa fa-qrcode </v-icon>
                    <span class="caption">CFDI</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                 <v-menu  v-if="valida_permiso_t('EmanifiestoAA.carta.porte.nueva') " open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">

                        <span v-on="on" id="menuCP">
                            <app-bar-item @click.native="hideMenuReportes">
                                <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Nueva Carta Porte
                                <v-icon>mdi-menu-right</v-icon>
                            </app-bar-item>
                        </span>
                    </template>
                    <v-list :tile="false" nav>
                        <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/administrar/nueva_carta">
                            <v-icon>mdi-circle-small</v-icon>Autotransporte
                        </app-bar-item>
                        <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/administrar/nueva_carta_maritima">
                            <v-icon>mdi-circle-small</v-icon>Marítimo
                        </app-bar-item>
                        <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/administrar/nueva_carta_aereo">
                            <v-icon>mdi-circle-small</v-icon>Aéreo
                        </app-bar-item>
                        <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/administrar/nueva_carta_ferroviaria">
                            <v-icon>mdi-circle-small</v-icon>Ferroviario
                        </app-bar-item>
                    </v-list>
                </v-menu>

                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.carta.porte.borradores')  " to="/carta_porte/administrar/borradores" @click.shift="openNew('/carta_porte/administrar/borradores');">
                    <v-icon>mdi-circle-small</v-icon>Borradores Carta Porte
                </app-bar-item>
                <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.carta.porte.refacturar')" to="/carta_porte/administrar/borradores_refacturar" @click.shift="openNew('/carta_porte/administrar/borradores_refacturar');">
                   <v-icon>mdi-circle-small</v-icon>Borradores Carta Porte Refacturación
               </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.carta.porte.consultar') " to="/carta_porte/administrar/cartas" @click.shift="openNew('/carta_porte/administrar/cartas');">
                    <v-icon>mdi-circle-small</v-icon>Consultar Carta Porte
                </app-bar-item>
              <v-divider />
              <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.cfdi.nueva')" to="/carta_porte/administrar/comercio_exterior" @click.shift="openNew('/carta_porte/administrar/nueva_carta');">
                    <v-icon>mdi-circle-small</v-icon>Nuevo CFDI
                </app-bar-item>
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.cfdi.borradores')" to="/carta_porte/administrar/borradoresce" @click.shift="openNew('/carta_porte/administrar/borradoresce');">
                    <v-icon>mdi-circle-small</v-icon>Borradores CFDI
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoAA.cfdi.consultar') " to="/carta_porte/administrar/comercio" @click.shift="openNew('/carta_porte/administrar/comercio');">
                    <v-icon>mdi-circle-small</v-icon>Consultar CFDI
                </app-bar-item>

            </v-list>
    </v-menu>
  
    <v-menu  v-if="es_agente && view_carta_porte"  text nav bottom offset-y origin="center center" transition="scale-transition">
     <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>file_copy</v-icon>
                    <span class="caption">Insumos SAT</span>
                </v-btn>
            </template>

        <v-list :tile="false" nav>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/productos">
                <v-icon>mdi-circle-small</v-icon>Productos y Servicios
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/materiales_peligrosos">
                <v-icon>mdi-circle-small</v-icon>Materiales Peligrosos
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/embalajes">
                <v-icon>mdi-circle-small</v-icon>Tipos de Embalajes
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/config_auto">
                <v-icon>mdi-circle-small</v-icon>Configuración Vehicular
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/ubicaciones">
                <v-icon>mdi-circle-small</v-icon>Ubicaciones
            </app-bar-item>
        </v-list>
    </v-menu>

</div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";



export default {
    name: "menuAA",

   
    created() {

       
        this.$local_storage.set("es_emanifiesto_logistico", this.$local_storage.get("EmanifiestoAA.Logistica.bitacora") == 100);

    },
    components: {
      
        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",
        fullWidth: document.documentElement.clientWidth,
        notifications: [
            "Mike John Responded to your email",
            "You have 5 new tasks",
            `You're now friends with Andrew`,
            "Another Notification",
            "Another one"
        ]
    }),

    computed: {
        ...mapState(["drawer"]),
       
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
      
        es_transportista() {
            return this.$local_storage.get("es_transportista")==1  && this.$local_storage.get("id_cliente") == 0 && this.$local_storage.get("id_grupo") > 0;
        },
        rfc_transportista() {
            return this.$local_storage.get("rfc_grupo"); ;
        },
        es_agente(){
            return this.$local_storage.get("es_agente")==1  && this.$local_storage.get("id_cliente") == 0 && this.$local_storage.get("id_grupo") > 0;
        },
        view_catalogos_manifiesto(){
            return (
                    this.valida_permiso_t("EmanifiestoAA.catalogos.clientes.crear") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.clientes.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.usuarios.crear") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.usuarios.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.sellos.editar") 
                   

            );
        },
        view_catalogos_cp(){
            return (
                   
                    this.valida_permiso_t("EmanifiestoAA.catalogos.receptores.crear") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.receptores.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.ubicaciones.crear") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.ubicaciones.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.servicios.crear") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.servicios.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.productos.crear") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.productos.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.mercancias.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.figuras.crear") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.figuras.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.remolques.crear") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.remolques.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.transportes.crear") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.transportes.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.catalogos.seguros.consultar")

            );
        },
        view_cfdi(){
             return (
                    this.valida_permiso_t("EmanifiestoAA.carta.porte.nueva") ||
                    this.valida_permiso_t("EmanifiestoAA.carta.porte.borradores") ||
                    this.valida_permiso_t("EmanifiestoAA.carta.porte.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.carta.porte.refacturar") ||
                    this.valida_permiso_t("EmanifiestoAA.cfdi.nueva") ||
                    this.valida_permiso_t("EmanifiestoAA.cfdi.borradores") ||
                    this.valida_permiso_t("EmanifiestoAA.cfdi.consultar")

            );
        },
        view_menu_carga(){
             return (
                    this.valida_permiso_t("EmanifiestoAA.archivom.cargar") ||
                    this.valida_permiso_t("EmanifiestoAA.archivom.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.facturas.cargar") ||
                    this.valida_permiso_t("EmanifiestoAA.facturas.consultar")
            );
        },
        view_menu_ds(){
             return (
                    this.valida_permiso_t("EmanifiestoAA.datastage.cargar") ||
                    this.valida_permiso_t("EmanifiestoAA.datastage.bitacora") ||
                    this.valida_permiso_t("EmanifiestoAA.datastage.reportes.directods") 
            );
        },
         view_menu_edrive_emanifiesto(){
             return (
                    this.valida_permiso_t("EmanifiestoAA.edrive.consultar") ||
                    this.valida_permiso_t("EmanifiestoAA.edrive.descargar")
            );
        },
         view_menu_reportes_emanifiesto(){
             return (
                     this.valida_permiso_t("EmanifiestoAA.reportes.comercio") ||
                    this.valida_permiso_t("EmanifiestoAA.reportes.comercio.detalle") ||
                    this.valida_permiso_t("EmanifiestoAA.reportes.directom") )
             ;
        },
        view_menu_reportes_cp(){
             return (
                   
                    this.valida_permiso_t("EmanifiestoAA.reportes.layout.cp")
             );
        },
        view_carta_porte() {
            return this.$store.state.carta_porte == 1;
        },
        esGrupo(){
            return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
        },

    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },
        valida_permiso_t(permiso) {
            return ( this.$local_storage.get(permiso) == 100 || ( this.$local_storage.get("id_perfil") == 0 && this.$local_storage.get("perfil_grupo") == 0 ));
        },
    
        openNew: function (h) {
            window.open(h, "_blank");
        },
       
        hideMenuReportes: function () {

          
            var menu6 = document.getElementById("menuCP");

        
            if (menu6) {
                menu6.click();
            }
        },
        hideMenuAdjuntos: function () {          
            var menu7 = document.getElementById("menuAdjuntos");    
            if (menu7) {
                menu7.click();
            }
        },
    },
   
};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
